import { router } from "@inertiajs/react";
import { ArrowRight, ShoppingBag } from "lucide-react";
import { motion } from "motion/react";

import { useCart } from "@/theme1/hooks/useCart";

export default function TopWantedActions({ product }) {
  const { add } = useCart();

  const handleBuyNow = () => {
    add(product, {
      quantity: 1,
      selectedColor: product.selectedColor || null,
      selectedSize: product.selectedSize || null,
    });

    router.visit("/checkout");
  };

  return (
    <motion.button
      type="button"
      whileTap={{ scale: 0.97 }}
      whileHover={{ y: -2 }}
      onClick={handleBuyNow}
      aria-label={`Buy ${product.title} now`}
      className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-full bg-black px-6 py-2.5 text-sm font-black uppercase tracking-wide text-white shadow-lg shadow-orange-500/20 transition hover:bg-black focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
    >
      <ShoppingBag className="size-4" />
      Buy Now
      <ArrowRight className="size-4" />
    </motion.button>
  );
}
